import {
  ONBOARDING_LOAD,
  ONBOARDING_COMPLETE_TOUR,
  ONBOARDING_MARK_ALL_COMPLETED,
  ONBOARDING_SET_ACTIVE_TOUR,
  ONBOARDING_RESET,
} from './onboardingSlice';

export const loadOnboarding = (userId) => ({
  type: ONBOARDING_LOAD,
  payload: { userId },
});

export const completeTour = (tourId) => ({
  type: ONBOARDING_COMPLETE_TOUR,
  payload: { tourId },
});

export const markAllCompleted = () => ({
  type: ONBOARDING_MARK_ALL_COMPLETED,
});

export const setActiveTour = (tourId) => ({
  type: ONBOARDING_SET_ACTIVE_TOUR,
  payload: tourId,
});

export const resetOnboarding = () => ({
  type: ONBOARDING_RESET,
});
